import { isAndroid } from "@memorang/helpers/platform";
import { useSafeAreaInsets } from "react-native-safe-area-context";
import { useDevice } from "../useDevice";

const useModalHeaderHeight = () => {
	const { top } = useSafeAreaInsets();
	const { isIpad } = useDevice();
	const statusBarHeight = isAndroid ? top : isIpad ? undefined : 0;
	return statusBarHeight;
};

export default useModalHeaderHeight;
